"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Image = _interopRequireDefault(require("../atoms/Image"));
var _Alert = _interopRequireDefault(require("../molecules/Alert"));
var _StatusChip = _interopRequireDefault(require("../molecules/StatusChip"));
var _Pricing = _interopRequireDefault(require("../molecules/Pricing"));
var _Column = _interopRequireDefault(require("../layout/Column"));
var _Row = _interopRequireDefault(require("../layout/Row"));
var _UIElementSizesEnum = require("../ts/enums/UIElementSizesEnum");
var _utils = require("../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const statusAsTypes = {
  prepared: 'info',
  picked: 'success',
  delivered: 'success',
  canceled: 'error',
  drafting: 'info'
};
function OrderSnapshot(_ref) {
  let {
    id,
    date,
    status,
    alert,
    docs,
    totalOfDocs,
    price,
    items,
    users,
    totalOfItems,
    fallbackImage,
    onClick
  } = _ref;
  const {
    colors
  } = (0, _react2.useTheme)();
  const statusAsAlert = (0, _react.useMemo)(() => {
    var _Object$values;
    return !!((_Object$values = Object.values(alert || {})) !== null && _Object$values !== void 0 && _Object$values.length);
  }, [alert]);
  const remainingTotalOfItems = (0, _react.useMemo)(() => totalOfItems - (items === null || items === void 0 ? void 0 : items.length), [totalOfItems, items === null || items === void 0 ? void 0 : items.length]);
  const doContainsDocs = (0, _react.useMemo)(() => Boolean(docs === null || docs === void 0 ? void 0 : docs.length), [docs]);
  const {
    hoursTime
  } = (0, _utils.chronos)(date).getTime();
  return /*#__PURE__*/_react.default.createElement(Container, {
    gap: 10,
    onClick: onClick
  }, statusAsAlert && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    size: _UIElementSizesEnum.UIElementSizesEnum.Small,
    type: alert === null || alert === void 0 ? void 0 : alert.type,
    title: alert === null || alert === void 0 ? void 0 : alert.title,
    description: alert === null || alert === void 0 ? void 0 : alert.description,
    show: statusAsAlert
  }), /*#__PURE__*/_react.default.createElement(StyledRowHeader, {
    align: "space-between"
  }, !statusAsAlert ? /*#__PURE__*/_react.default.createElement(StyledStatusChip, {
    type: statusAsTypes[status],
    text: String(id),
    textColor: colors.FONT.TITLE,
    textSize: 16,
    iconSize: 15
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    weight: 700,
    size: 16,
    children: String(id)
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "description",
    size: 12,
    children: hoursTime
  })), /*#__PURE__*/_react.default.createElement(_Row.default, {
    align: "space-between"
  }, /*#__PURE__*/_react.default.createElement(StyledItemsRow, {
    gap: 10
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 5
  }, items === null || items === void 0 ? void 0 : items.map((image, index) => /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: image || '',
    alt: "Product image ".concat(index),
    fallback: fallbackImage,
    key: index,
    width: 50,
    height: 50
  }))), /*#__PURE__*/_react.default.createElement(TotalOfRemainingItems, {
    type: "description",
    size: 16,
    show: remainingTotalOfItems > 0,
    children: "+".concat(remainingTotalOfItems)
  })), /*#__PURE__*/_react.default.createElement(UsersContainer, null, users === null || users === void 0 ? void 0 : users.map((image, index) => image ? /*#__PURE__*/_react.default.createElement(ImageContainer, {
    position: index,
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: image,
    width: 35,
    height: 35,
    rounded: 100
  })) : /*#__PURE__*/_react.default.createElement(DefaultProfileImage, {
    name: "person",
    key: index,
    size: 15,
    color: "white",
    position: index
  })))), /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 15,
    align: doContainsDocs ? 'space-between' : 'right',
    styles: cssBottomStyles
  }, doContainsDocs && /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "helper",
    weight: 700,
    size: 12,
    children: "Documentos adicionales ".concat(Boolean(totalOfDocs) ? "(".concat(totalOfDocs, ")") : '')
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    numberOfLines: 1,
    children: docs,
    size: 15
  })), /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: "helper",
    weight: 700,
    size: 12,
    align: "right",
    children: "Total"
  }), /*#__PURE__*/_react.default.createElement(_Pricing.default, {
    weight: 700,
    size: 16,
    currencyCode: price === null || price === void 0 ? void 0 : price.currencyCode,
    currencySize: 10,
    amount: price === null || price === void 0 ? void 0 : price.amount,
    align: "right"
  }))));
}
const Container = (0, _styled.default)(_Column.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
const StyledRowHeader = (0, _styled.default)(_Row.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    span.material-icons {\n      font-size: 20px;\n      padding: 4px;\n    }\n\n    p[type='default'] {\n      font-size: 22px !important;\n    }\n    p[type='description'] {\n      font-size: 18px !important;\n    }\n  }\n"])));
const StyledStatusChip = (0, _styled.default)(_StatusChip.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
const StyledItemsRow = (0, _styled.default)(_Row.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  [data-image-is-fallback='true'],\n  p[type='description'] {\n    font-size: 18px;\n    width: 20px;\n    height: 20px;\n    padding: 15px;\n    background-color: ", ";\n  }\n\n  @media screen and (min-width: 768px) {\n    gap: 15px;\n    padding-top: 5px;\n\n    img {\n      width: 65px;\n      height: 65px;\n    }\n\n    [data-image-is-fallback='true'],\n    p[type='description'] {\n      width: 20px;\n      height: 20px;\n      font-size: 20px;\n      padding: 22.5px;\n    }\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.NEUTRAL.SIDE;
});
const UsersContainer = _styled.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 35px;\n  height: 35px;\n\n  @media screen and (min-width: 768px) {\n    width: 42px;\n    height: 42px;\n  }\n"])));
const userProfileStyles = position => (0, _react2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  z-index: ", ";\n  left: -", "px;\n  top: -", "px;\n\n  @media screen and (min-width: 768px) {\n    img {\n      width: 42px;\n      height: 42px;\n    }\n\n    width: 42px;\n    height: 42px;\n    left: -", "px;\n    top: -", "px;\n  }\n"])), 3 - position, 10 * position, 10 * position, 15 * position, 15 * position);
const ImageContainer = _styled.default.figure(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  ", "\n"])), _ref3 => {
  let {
    position
  } = _ref3;
  return userProfileStyles(position);
});
const DefaultProfileImage = (0, _styled.default)(_Icon.default)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 35px;\n  user-select: none;\n  position: absolute;\n\n  @media screen and (min-width: 768px) {\n    font-size: 22px;\n  }\n\n  ", "\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.FONT.HELPER;
}, _ref5 => {
  let {
    position
  } = _ref5;
  return userProfileStyles(position);
});
const TotalOfRemainingItems = (0, _styled.default)(_Typography.default)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 45px;\n  height: 45px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n\n  ", "\n"])), _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.NEUTRAL.SIDE;
}, _ref7 => {
  let {
    show
  } = _ref7;
  return !show && 'display: none;';
});
const cssBottomStyles = (0, _react2.css)(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    p[type='helper'] {\n      font-size: 16px;\n    }\n\n    div:first-of-type > p[type='default'] {\n      font-size: 18px !important;\n    }\n\n    div:last-of-type > p[type='default'] {\n      font-size: 22px !important;\n\n      &::after {\n        font-size: 16px;\n      }\n    }\n  }\n"])));
var _default = exports.default = OrderSnapshot;